/** API route map: URLS.Controller.User */
export const User = {
      Name: 'User/',
      // Rights: 'get-rights',
      GetAll: 'get-users',
      GetAllUsers: 'get-allusers',
      AddUser: 'add-user',
      SetUserStatus: 'set-userstatus',
      GetDBUser: 'get-db-users',
      GetDBUserAdmin: 'get-db-users-admin',
      SetPassword: 'set-userpassword',
      GetById: 'get-userbyid',
      UpdateUser: 'update-user',
      getLoggedinUser: 'get-loggedin-user',
      Patch: 'patch',
      ChangeUserPassword: 'change-userpassword',
      UpdateUserProfileImage: 'update-user-profile-image',
      GetAllUsersForDepartment: 'get-allusers-for-department',
      GetAllClientGuests: 'get-clients-guest-users',
      GetUserApplicationRights: 'get-user-application-rights',
      setDefaultClient: 'set-default-client',
      GetCompany: 'get-company',
      LinkExpiry: 'link-expiry',
      // EN-31677 — actively expires a reset token whose verification code is no longer valid.
      ExpireLink: 'expire-link',
      SendForgotPasswordEmail: 'send-email',
      VerifyCode: 'verify-code',
      CheckTimer: 'check-time-expired',
      ResendCode: 'resend-code',
      ResetPassword: 'reset-userpassword',
      EmployeeAccess: 'get-employee-access',
      // EN-24306 — the clients (one employee row each) the login can switch between.
      GetMyClients: 'get-my-clients',
      // EN-32350 — legacy users (username = email), after the forgot-password code is verified.
      LegacyResetStatus: 'legacy-reset-status',
      LegacyVerifyName: 'legacy-verify-name',
};
